// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OutfitsButton-button-bf91{height:100% !important;border-radius:0}.OutfitsButton-dot-bf91{width:6px;height:6px;border-radius:99px;background-color:#fc1f4b}`, "",{"version":3,"sources":["webpack://./src/page/Header/OutfitsButton.module.scss"],"names":[],"mappings":"AAAA,2BACE,sBAAA,CACA,eAAA,CAGF,wBACE,SAAA,CACA,UAAA,CACA,kBAAA,CACA,wBAAA","sourcesContent":[".button {\n  height: 100% !important;\n  border-radius: 0;\n}\n\n.dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 99px;\n  background-color: #FC1F4B;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `OutfitsButton-button-bf91`,
	"dot": `OutfitsButton-dot-bf91`
};
module.exports = ___CSS_LOADER_EXPORT___;
